import React from 'react'
import parse from 'html-react-parser'

function Content({ content, className }) {
  return <div className={className}>{parse(content)}</div>
}

export default Content
